// src/components/DashBoard/DashboardData.js

import React from "react";

const DashboardData = (props) => {
  const data = [
    { text: "Linda Jones has a birthday today.", color: "#007BFF" },
    { text: "Scott Work anniversary today (Completed 1 year).", color: "#007BFF" },
    { text: "Steve has work anniversary today (Completed 2 years in Johnson & Nagich).", color: "green" },
    { text: "Clark has work anniversary today (Completed 2 years in Johnson & Nagich).", color: "green" },
    { text: "Diego Cook has a birthday today.", color: "#007BFF" },
    { text: "James Firm have an anniversary today.", color: "green" },
    { text: "John Martin have an anniversary today.", color: "#007BFF" }
  ];

//   function closeAllModalFunc(){
//     props?.setCloseModal(true)
// }


  return (
    <div className="divHeight " >
      <h1 class="page-title ">Welcome to Life Point Law. <small>Today is Friday, April 10, 2026</small> </h1>
      <div style={{   border: "1px solid #b5c0c0",   fontFamily: "Arial",   width: "100%" }} >
  {/* HEADER */}


  <div style={{   background: "#95a5a6",   color: "white",   display: "flex",   justifyContent: "space-between",   alignItems: "center",   padding: "10px 12px",   cursor: "pointer" }}
    onClick={() => {
      const content = document.getElementById("alertBox");
      content.style.display =
        content.style.display === "none" ? "block" : "none";
    }}
  >
    {/* LEFT SIDE */}
    <div className="justify-content-start" style={{ display: "flex", alignItems: "center", gap: "" }}>
      <span><i class="fa fa-bell" aria-hidden="true" style={{fontSize: "15px"}}></i></span>
      <span className="fsizeAlert ms-2">You have new alert(s)</span>
      <span style={{   background: "white",   color: "#333",   borderRadius: "50%",   padding: "2px 7px",   fontSize: "12px" }} className="ms-2" >6</span>
    </div>

    {/* RIGHT ICONS */}
    <div style={{ display: "flex", gap: "10px" }}>
      <span><i class="fa fa-chevron-down text-white" aria-hidden="true"></i></span>
      <span><i class="fa fa-refresh text-white" aria-hidden="true"></i></span>
    </div>
  </div>

  {/* CONTENT */}
  <div
    id="alertBox"
    style={{
      background: "white",
      padding: "12px",
      borderTop: "1px solid #b5c0c0"
    }}
  >
    <p style={{ margin: "10px 0", color: "" }}>
      <span style={{ margin: "10px 0", color: "#007BFF" }}>Linda Jones</span> <span>has a birthday today.</span>
    </p>

    <p style={{ margin: "10px 0", color: "" }}>
      <span style={{ margin: "10px 0", color: "#007BFF" }}> Scott</span> work anniversary today (Completed 1 year).
    </p>

    <p style={{ margin: "10px 0", color: "" }}>
      <span style={{ margin: "10px 0", color: "green" }}>Steve </span> has work anniversary today (Completed 2 years in Johnson & Nagaich)
    </p>

    <p style={{ margin: "10px 0", color: "" }}>
      <span style={{ margin: "10px 0", color: "green" }}>Clark </span> has work anniversary today (Completed 2 years in Johnson & Nagaich)
    </p>

    <p style={{ margin: "10px 0", color: "" }}>
      <span style={{ margin: "10px 0", color: "#007BFF" }}>Diego Cook</span> has a birthday today.
    </p>

    <p style={{ margin: "10px 0", color: "" }}>
      <span style={{ margin: "10px 0", color: "green" }}> James Firm </span>have an anniversary today.
    </p>

    <p style={{ margin: "10px 0", color: "" }}>
    <span style={{ margin: "10px 0", color: "007BFF" }}>John Martin </span>have an anniversary today.
    </p>
  </div>

      </div>
      
      <div className="mt-5"  style={{   border: "1px solid #b1bdbd",borderTop: "0"}}>
      {/*  */}

      <div style={{    background: "#95a5a6",   color: "white",   display: "flex",   justifyContent: "space-between",   alignItems: "center",   padding: "10px 12px",   cursor: "pointer" }}
          onClick={() => {
            const content = document.getElementById("alertBox2");
            content.style.display =
              content.style.display === "none" ? "block" : "none";
          }}
       >
    {/* LEFT SIDE */}
    <div className="justify-content-start" style={{ display: "flex", alignItems: "center", gap: "" }}>
      <span> <i class="fa fa-envelope" style={{fontSize: "15px"}}></i></span>
      <span className="fsizeAlert ms-2">You have new messages(s)</span>
      <span style={{   background: "white",   color: "#333",   borderRadius: "50%",   padding: "2px 7px",   fontSize: "12px" }} className="ms-2" >7</span>
    </div>

    {/* RIGHT ICONS */}
    <div style={{ display: "flex", gap: "10px" }}>
      <span><i class="fa fa-chevron-down text-white" aria-hidden="true"></i></span>
      <span><i class="fa fa-refresh text-white" aria-hidden="true"></i></span>
    </div>
  </div>

  {/* CONTENT */}
  <div class="search-box chnageDesign">
              <label>Search: </label>
              <input type="text" className=""/>
  </div>
  <div id="alertBox2">
  <table class="message-table"  >
              <thead>
              <tr>
                <th>
                  <div className="th-content">
                    Date and Time
                    <span className="sort-icons">
                    <i class="fa fa-sort"></i>
                    </span>
                  </div>
                </th>

                <th>
                  <div className="th-content">
                    User Type
                    <span className="sort-icons">
                    <i class="fa fa-sort"></i>
                    </span>
                  </div>
                </th>

                <th>
                  <div className="th-content">
                    From
                    <span className="sort-icons">
                    <i class="fa fa-sort"></i>
                    </span>
                  </div>
                </th>

                <th>
                  <div className="th-content">
                    Subject
                    <span className="sort-icons">
                    <i class="fa fa-sort"></i>
                    </span>
                  </div>
                </th>

                <th>
                  <div className="th-content">
                    Message Body
                    <span className="sort-icons">
                    <i class="fa fa-sort"></i>
                    </span>
                  </div>
                </th>
                <th>
                  <div className="th-content">
                  View
                    <span className="sort-icons">
                    <i class="fa fa-sort"></i>
                    </span>
                  </div>
                </th>
              </tr>
              </thead>
              <tbody>
                  <tr>
                      <td>11/02/2026 09:04PM</td>
                      <td>Admin Staff</td>
                      <td>James Smith</td>
                      <td>dolor sit amet</td>
                      <td>Lorem ipsum dolor sit amet, consectetur adipiscing elit...</td>
                      <td><i class="fa fa-eye"></i></td>
                  </tr>
                  <tr>
                      <td>11/07/2026 03:07PM</td>
                      <td>Firm</td>
                      <td>John Martin</td>
                      <td>dolor sit amet</td>
                      <td>Lorem ipsum dolor sit amet, consectetur adipiscing elit...</td>
                      <td><i class="fa fa-eye"></i></td>
                  </tr>
                  <tr>
                      <td>15/03/2026 04:05PM</td>
                      <td>Admin Staff</td>
                      <td>Mr. John Martin</td>
                      <td>ipsum</td>
                      <td>Lorem ipsum dolor sit amet, consectetur adipiscing elit...</td>
                      <td><i class="fa fa-eye"></i></td>
                  </tr>
                  <tr>
                      <td>11/02/2026 06:14PM</td>
                      <td>Firm</td>
                      <td>John Martin</td>
                      <td>ipsum</td>
                      <td>Lorem ipsum dolor sit amet, consectetur adipiscing elit...</td>
                      <td><i class="fa fa-eye"></i></td>
                  </tr>
                  <tr>
                      <td>15/02/2026 07:04PM</td>
                      <td>Firm Staff</td>
                      <td>John Martin</td>
                      <td>dolor sit amet</td>
                      <td>Lorem ipsum dolor sit amet, consectetur adipiscing elit...</td>
                      <td><i class="fa fa-eye"></i></td>
                  </tr>
                  <tr>
                      <td>01/03/2026 09:04PM</td>
                      <td>Admin Staff</td>
                      <td>John Martin</td>
                      <td>ipsum</td>
                      <td>Lorem ipsum dolor sit amet, consectetur adipiscing elit...</td>
                      <td><i class="fa fa-eye"></i></td>
                  </tr>
              </tbody>
              <div class="dataTables_info" id="grid_info" role="status" aria-live="polite">Showing 1 to 7 of 7 entries</div>
    </table>
  </div >


      {/*  */}

      
      </div>
      <div class="stats-container">

          <div class="stats-header">
              <div class="title">
                  Event Statistics (for last 30 days)
              </div>

              <div class="period_select">
                  <label>Select Period: </label>
                  <select>
                      <option>Last 30 Days</option>
                  </select>
              </div>
          </div>


          <div class="divider">
              <span class="notch"></span>
          </div>


          <div class="stats-content">

              <div class="circle-box">
                  <div class="circle blue">
                      <span>80</span>
                  </div>
                  <p>Death</p>
              </div>

              <div class="circle-box">
                  <div class="circle green">
                      <span>55</span>
                  </div>
                  <p>End of Life</p>
              </div>

              <div class="circle-box">
                  <div class="circle orange">
                      <span>68</span>
                  </div>
                  <p>Illness</p>
              </div>

          </div>

      </div>

          {/*  */}
          <div className="event-container">

          {/* Header */}
          <div className="event-header">
            Event Information
          </div>

          {/* Divider with notch */}
          <div className="event-divider">
            <span className="event-notch"></span>
          </div>

          {/* Tabs */}
          <div className="event-tabs">
            <div className="tab active">
              <i className="fa fa-birthday-cake"></i> Birthdays
            </div>
            <div className="tab">
              <i className="fa fa-gift"></i> Anniversaries
            </div>
            <div className="tab">
              <i className="fa fa-briefcase"></i> Work Anniversaries
            </div>
            <div className="tab">
              <i className="fa fa-bed"></i> Death
            </div>
            <div className="tab">
              <i className="fa fa-medkit"></i> Illness
            </div>
            <div className="tab">
              <i className="fa fa-file-text"></i> End Of Life
            </div>
          </div>

          {/* Table */}
          <div className="event-table-wrapper">
            <table className="event-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone Number</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>James Smith</td>
                  <td>james@bbpf.com</td>
                  <td>+1846255445</td>
                  <td>4/11/1994</td>
                </tr>
                <tr>
                  <td>Logan Robinson</td>
                  <td>robinson@bbpf.com</td>
                  <td>+1782255556</td>
                  <td>4/11/1984</td>
                </tr>
                <tr>
                  <td>Matthew Baker</td>
                  <td>mbaker@bbpf.com</td>
                  <td>+1852468844</td>
                  <td>4/11/1998</td>
                </tr>
                <tr>
                  <td>John Martin</td>
                  <td>martin@bbpf.com</td>
                  <td>+1882558255</td>
                  <td>4/11/2001</td>
                </tr>
                <tr>
                  <td>Julie Garcia</td>
                  <td>garcia@bbpf.com</td>
                  <td>+1842255558</td>
                  <td>4/11/2011</td>
                </tr>
                <tr>
                  <td>Joshua Cooper</td>
                  <td>cooperj@bbpf.com</td>
                  <td>+1846785899</td>
                  <td>4/11/1986</td>
                </tr>
                <tr>
                  <td>Diego Cook</td>
                  <td>diegocook@bbpf.com</td>
                  <td>+1846782255</td>
                  <td>4/11/1980</td>
                </tr>
              </tbody>
            </table>
          </div>

          </div>
          {/*  */}
          <div className="mb-5 pb-5">
          </div>
    </div>
  );
};

export default DashboardData;